/* i18n helper (global) */
if(typeof window!=="undefined" && typeof window.TR==="undefined"){window.TR=function(k,v){return (window.GS&&GS.t)?GS.t(k,v):k;};}
var TR=window.TR;
/*! GhostStat Marketing Campaigns — UTM campaigns, channels, ROI, groups. */
(function () {
  function TT(k){ return (window.GS&&GS.t)?GS.t(k):k; }
  "use strict";
  /* Answers "is the deployed file the new one?" without a deploy archaeology session. If the
     console does not say 1.0.1, a stale edge copy is being served — purge the CDN. */
  try { (window.GS_BUILD = window.GS_BUILD || {})["marketing-campaigns"] = "1.0.3"; } catch (e) {}
  var root, DATA=null, CAMPS=[], CUR="USD", CHANFILTER=null;
  var SYM={USD:"$",EUR:"\u20AC",GBP:"\u00A3",CAD:"C$",AUD:"A$",JPY:"\u00A5"};
  function q(n){ return root?root.querySelector('[data-d="'+n+'"]'):null; }
  function qa(s){ return root?Array.prototype.slice.call(root.querySelectorAll(s)):[]; }
  function esc(s){ return String(s==null?"":s).replace(/[&<>"]/g,function(c){return {"&":"&amp;","<":"&lt;",">":"&gt;","\"":"&quot;"}[c];}); }
  function nf(n){ return (+n||0).toLocaleString(); }
  function money(v){ if(v===null||v===undefined)return "—"; return (SYM[CUR]||"")+(+v).toLocaleString(undefined,{minimumFractionDigits:2,maximumFractionDigits:2}); }
  function ready(fn){ var d=false; function go(){ if(d)return; d=true; fn(); }
    document.addEventListener("gs:ready",go,{once:true});
    var n=0,t=setInterval(function(){ if(window.GS&&GS.api&&GS.site){clearInterval(t);go();} else if(++n>200)clearInterval(t); },30);
    if(window.GS&&GS.api&&GS.site)go(); }
  function api(path,opts){ return GS.api(path+(path.indexOf("?")<0?"?":"&")+"site="+encodeURIComponent(GS.site),opts); }

  function load(){
    api("/plugin/marketing-campaigns/list?from="+RANGE.from+"&to="+RANGE.to).then(function(r){
      if(!r.ok||!r.data)return; DATA=r.data; CAMPS=DATA.campaigns||[];
      var T=DATA.totals||{};
      q("k-camps").textContent=nf(T.campaigns); q("k-sess").textContent=nf(T.sessions); q("k-conv").textContent=nf(T.conversions); q("k-rev").textContent=money(T.revenue);
      var rw=q("k-roi-wrap"); if(DATA.has_cost&&T.roi!==null){ rw.hidden=false; q("k-roi").textContent=(T.roi>=0?"+":"")+T.roi+"%"; q("k-roi").className="v "+(T.roi>=0?"pos":"neg"); } else rw.hidden=true;
      renderChannels(DATA.channels||[]); renderGroups(DATA.groups||[]); renderCampaigns(CAMPS);
      qa(".cost").forEach(function(el){ el.style.display=DATA.has_cost?"":"none"; });
    });
  }
  function renderChannels(chs){
    var host=q("channels"); var max=Math.max.apply(null,chs.map(function(c){return c.sessions;}).concat([1]));
    host.innerHTML= chs.length? chs.map(function(c){
      return '<div class="mc-chrow'+(CHANFILTER===c.channel?" active":"")+'" data-ch="'+esc(c.channel)+'" role="button" tabindex="0" title="Filter campaigns to '+esc(c.channel)+'"><span class="mc-chname"><i class="mc-dot" style="background:'+c.color+'"></i>'+esc(c.channel)+'</span>'+
        '<span class="mc-chbar"><i style="width:'+Math.max(2,c.sessions/max*100)+'%;background:'+c.color+'"></i></span>'+
        '<span class="mc-chv">'+nf(c.sessions)+'</span></div>';
    }).join("") : '<div class="empty">'+TR('mc.f.no_campaign_traffic_in_this_range')+'</div>';
    Array.prototype.forEach.call(host.querySelectorAll("[data-ch]"), function(el){
      var go=function(){ var ch=el.getAttribute("data-ch"); setChannel(CHANFILTER===ch?null:ch); };
      el.onclick=go; el.onkeydown=function(e){ if(e.key==="Enter"||e.key===" "){ e.preventDefault(); go(); } };
    });
  }
  /* Channel filter — set from the breakdown, the clear chip, or a ?channel= deep-link. */
  function setChannel(ch){
    CHANFILTER = ch || null;
    try { var u=new URL(location.href); if(CHANFILTER)u.searchParams.set("channel",CHANFILTER); else u.searchParams.delete("channel"); history.replaceState(null,"",u.toString()); } catch(e){}
    renderChannels(DATA&&DATA.channels||[]); renderCampaigns(CAMPS);
  }
  function updateChip(){
    var tb=q("camp-tbody"); if(!tb)return; var tbl=tb.closest("table"); if(!tbl)return;
    var chip=root.querySelector('[data-mc="chanchip"]');
    if(CHANFILTER){
      if(!chip){ chip=document.createElement("div"); chip.setAttribute("data-mc","chanchip"); chip.className="mc-chanchip"; tbl.parentNode.insertBefore(chip,tbl); }
      chip.innerHTML='Showing <b>'+esc(CHANFILTER)+'</b> campaigns <button class="mc-chanx" data-mc="chanx" aria-label="'+TT('mc.at.clear_channel_filter')+'">&times;</button>';
      chip.hidden=false;
      var x=chip.querySelector('[data-mc="chanx"]'); if(x)x.onclick=function(){ setChannel(null); };
    } else if(chip){ chip.hidden=true; }
  }
  function renderGroups(gs){
    var card=q("groups-card"); if(!gs.length){ card.hidden=true; return; } card.hidden=false;
    q("groups-tbody").innerHTML=gs.map(function(g){ var m=g.metrics||{};
      return '<tr data-grp="'+g.id+'"><td class="nm">'+esc(g.name)+'</td><td class="r">'+m.member_count+"</td><td class=\"r\">"+nf(m.sessions)+"</td><td class=\"r\">"+nf(m.conversions)+"</td><td class=\"r\">"+money(m.revenue)+"</td>"+
        '<td class="r">'+(m.roi===null?"—":(m.roi>=0?"+":"")+m.roi+"%")+"</td><td class=\"ar\"><button class=\"lnk\" data-editg=\""+g.id+"\">"+TR('mc.f.edit')+"</button> <button class=\"lnk del\" data-delg=\""+g.id+"\">"+TR('mc.f.delete')+"</button></td></tr>";
    }).join("");
    qa("[data-editg]").forEach(function(b){ b.onclick=function(){ openGroup(+b.getAttribute("data-editg")); }; });
    qa("[data-delg]").forEach(function(b){ b.onclick=function(){ if(confirm(TT('mc.x.delete_this_group_campaigns_are_no')))api("/plugin/marketing-campaigns/group",{method:"POST",body:JSON.stringify({action:"delete",id:+b.getAttribute("data-delg")})}).then(load); }; });
  }
  function renderCampaigns(cs){
    var tb=q("camp-tbody");
    function mcCampRow(c){
      return '<tr data-camp="'+esc(c.campaign)+'"><td class="nm">'+esc(c.campaign)+'<div class="mc-sm gs-muted">'+esc(c.source||"")+(c.medium?" / "+esc(c.medium):"")+'</div></td>'+
        '<td><span class="mc-chip" style="background:'+c.channel_color+'22;color:'+c.channel_color+'">'+esc(c.channel)+'</span></td>'+
        '<td class="r">'+nf(c.sessions)+"</td><td class=\"r\">"+nf(c.visitors)+"</td><td class=\"r\">"+nf(c.conversions)+'<div class="mc-sm gs-muted">'+c.conv_rate+"%</div></td><td class=\"r\">"+money(c.revenue)+"</td>"+
        '<td class="r cost">'+(c.cost>0?money(c.cost):"—")+"</td><td class=\"r cost\">"+money(c.cpc)+"</td><td class=\"r cost\">"+money(c.cpa)+"</td>"+
        '<td class="r cost">'+(c.roas===null?"—":c.roas+"×")+"</td><td class=\"r cost\">"+(c.roi===null?"—":'<span class="'+(c.roi>=0?"pos":"neg")+'">'+(c.roi>=0?"+":"")+c.roi+"%</span>")+"</td></tr>";
    }
    cs = cs || [];
    var rows = CHANFILTER ? cs.filter(function(c){ return c.channel===CHANFILTER; }) : cs;
    var emptyText = CHANFILTER ? ("No campaigns in the "+CHANFILTER+" channel for this range.") : TR('mc.f.no_utm_tagged_campaigns_in_this_range_');
    if (window.GSMore) GSMore.mount({ container:tb, table:true, colspan:11, items:rows, pageSize:20, emptyText:emptyText, render:mcCampRow });
    else tb.innerHTML = rows.length ? rows.map(mcCampRow).join("") : '<tr><td colspan="11" class="empty">'+esc(emptyText)+'</td></tr>';
    updateChip();
    // Delegated: covers campaign rows revealed by "Load more"; buttons inside still opt out.
    if(!tb._mcDelegated){ tb._mcDelegated=1; tb.addEventListener("click",function(e){ if(e.target.closest("button"))return; var tr=e.target.closest&&e.target.closest("tr[data-camp]"); if(tr) openDetail(tr.getAttribute("data-camp")); }); }
    qa(".cost").forEach(function(el){ el.style.display=(DATA&&DATA.has_cost)?"":"none"; });
  }

  /* Campaign timeline. Deliberately still a sparkline — it sits inline in the detail panel, where full
     axes would dominate a 52px strip — but it no longer hides its numbers: the peak is labelled, and
     every day has a hover readout (data-tip, which the app tooltip engine picks up automatically).
     preserveAspectRatio stays uniform so the label isn't stretched. */
  /* Local number formatter: GSUI is app-wide, but a plugin should not throw if it renders before
     components.js has defined it. */
  function nfmt(v){ if (window.GSUI && GSUI.fmt) return nfmt(v);
    v=+v||0; return v>=1e6?(v/1e6).toFixed(1)+"M":v>=1e3?(v/1e3).toFixed(1)+"k":String(Math.round(v)); }
  function spark(vals, days){
    if(!vals.length) return '<div class="gs-muted small">'+TR('mc.f.no_data')+'</div>';
    days = days || [];
    var max=Math.max.apply(null,vals)||1, n=vals.length;
    var W=Math.max(n*10,160), H=48, T=10, B=4, PH=H-T-B;
    var X=function(i){ return n<2 ? W/2 : i/(n-1)*W; };
    var Y=function(v){ return T+PH-(v/max)*PH; };
    var pts=vals.map(function(v,i){ return X(i).toFixed(1)+","+Y(v).toFixed(1); }).join(" ");
    var colw = n>1 ? W/(n-1) : W;
    var hit='', peakI=vals.indexOf(max);
    vals.forEach(function(v,i){
      var d = days[i] ? String(days[i]) : ('Day '+(i+1));
      hit += '<rect x="'+(X(i)-colw/2).toFixed(1)+'" y="'+T+'" width="'+colw.toFixed(1)+'" height="'+PH+
             '" fill="transparent" data-tip="'+esc(d)+' \u2014 '+nfmt(v)+' sessions"></rect>';
    });
    /* One number on the chart: the peak, anchored so it never runs off either edge. */
    var lx = X(peakI), anchor = peakI===0 ? 'start' : (peakI===n-1 ? 'end' : 'middle');
    var peak = '<text x="'+lx.toFixed(1)+'" y="'+Math.max(8,(Y(max)-4)).toFixed(1)+'" text-anchor="'+anchor+
               '" font-size="9" fill="#6b7280">peak '+nfmt(max)+'</text>';
    return '<svg viewBox="0 0 '+W+' '+H+'" preserveAspectRatio="xMidYMid meet" style="width:100%;height:52px" '+
      'role="img" aria-label="Sessions per day, peak '+nfmt(max)+'">'+
      '<polyline points="0,'+(T+PH)+' '+pts+' '+W+','+(T+PH)+'" fill="rgba(31,164,99,.10)" stroke="none"/>'+
      '<polyline points="'+pts+'" fill="none" stroke="#1FA463" stroke-width="2" stroke-linejoin="round"/>'+
      peak+hit+'</svg>'; }
  function openDetail(name){
    if (window.GSLink) window.GSLink.write({ campaign: name });   // the open view becomes linkable
    api("/plugin/marketing-campaigns/get?campaign="+encodeURIComponent(name)+"&from="+RANGE.from+"&to="+RANGE.to).then(function(r){
      if(!r.ok||!r.data)return; var d=r.data, sec=q("detail"); sec.hidden=false;
      q("det-title").textContent=name; q("d-sess").textContent=nf(d.sessions); q("d-vis").textContent=nf(d.visitors); q("d-conv").textContent=nf(d.conversions); q("d-rev").textContent=money(d.revenue);
      q("d-timeline").innerHTML=spark((d.timeline||[]).map(function(x){return x.sessions;}),
        (d.timeline||[]).map(function(x){return x.day||x.d||x.date;}));
      q("d-breakdown").innerHTML=(d.breakdown||[]).map(function(b){ return '<tr><td>'+esc(b.label)+'</td><td class="r">'+nf(b.sessions)+"</td><td class=\"r\">"+nf(b.conversions)+"</td><td class=\"r\">"+money(b.revenue)+"</td></tr>"; }).join("")||'<tr><td colspan="4" class="empty">'+TR('mc.f.no_breakdown')+'</td></tr>';
      sec.scrollIntoView({behavior:"smooth",block:"nearest"});
    });
  }

  // group builder
  function openGroup(id){
    var m=q("grp-modal");
    var chosen={}; var run=function(g){
      m.querySelector('[data-f="id"]').value=g?g.id:""; m.querySelector('[data-f="name"]').value=g?g.name:""; m.querySelector('[data-f="type"]').value=g?g.type:"custom";
      (g&&g.members||[]).forEach(function(mn){ chosen[mn]=1; });
      q("grp-camplist").innerHTML= CAMPS.length? CAMPS.map(function(c){ return '<label class="mc-cchk"><input type="checkbox" value="'+esc(c.campaign)+'" '+(chosen[c.campaign]?"checked":"")+'> <span>'+esc(c.campaign)+'</span> <span class="gs-muted">'+esc(c.channel)+'</span></label>'; }).join("") : '<div class="gs-muted small">'+TR('mc.f.no_campaigns_to_group_yet')+'</div>';
      q("grp-title").textContent=id?"Edit group":TR('mc.f.new_group'); m.hidden=false;
    };
    if(id){ var g=(DATA.groups||[]).filter(function(x){return x.id===id;})[0]; run(g||null); } else run(null);
  }
  function saveGroup(){
    var m=q("grp-modal");
    var members=Array.prototype.slice.call(q("grp-camplist").querySelectorAll("input:checked")).map(function(i){return i.value;});
    var body={action:"save",id:+m.querySelector('[data-f="id"]').value||0,name:m.querySelector('[data-f="name"]').value,type:m.querySelector('[data-f="type"]').value,members:members};
    api("/plugin/marketing-campaigns/group",{method:"POST",body:JSON.stringify(body)}).then(function(r){ if(r.ok){ m.hidden=true; load(); } });
  }
  // import
  function runImport(){
    var csv=q("imp-modal").querySelector('[data-f="csv"]').value;
    api("/plugin/marketing-campaigns/import",{method:"POST",body:JSON.stringify({csv:csv})}).then(function(r){
      var msg=q("imp-msg"); if(r.ok){ msg.className="mc-impmsg ok"; msg.textContent="Imported "+r.data.imported+" rows."; setTimeout(function(){ q("imp-modal").hidden=true; load(); },700); }
      else { msg.className="mc-impmsg err"; msg.textContent="Import failed: "+(r.data&&r.data.error||"check the format"); }
    });
  }

  function _ymd(d){ return d.getUTCFullYear()+"-"+("0"+(d.getUTCMonth()+1)).slice(-2)+"-"+("0"+d.getUTCDate()).slice(-2); }
  function _today(){ var t=new Date(); return new Date(Date.UTC(t.getFullYear(),t.getMonth(),t.getDate())); }
  function T(k,v){return (window.GS&&GS.t)?GS.t(k,v):k;}
  function preset(days){ var to=_today(),from=new Date(to.getTime()-(days-1)*86400000); var lbl={7:T("an.last7"),30:T("an.last30"),90:T("an.last90")}[days]||T("an.lastndays",{n:days}); return {from:_ymd(from),to:_ymd(to),label:lbl,preset:String(days)}; }
  var RANGE=(function(){ try{ var s=JSON.parse(localStorage.getItem("gs_mc_range")||"null"); /* A stored preset is a RULE ("last 30 days"), not a fixed window. Restoring its
     absolute from/to means "last 30 days" quietly becomes "the 30 days ending whenever
     you last touched the picker" — today falls outside the range, the page looks stale,
     and Refresh re-queries the same dead window forever. Re-anchor presets to today;
     a CUSTOM range is genuinely absolute and is kept as stored. */
  if (s && s.preset) return preset(+s.preset);
  if(s&&s.from)return s; }catch(e){} return preset(30); })();
  function initRange(){
    var btn=q("rangeBtn"),menu=q("rangeMenu"),lab=q("range-label"); if(!btn)return;
    if(lab&&RANGE.label)lab.textContent=RANGE.label;
    btn.addEventListener("click",function(e){ if(menu.contains(e.target)&&e.target!==btn)return; e.stopPropagation(); menu.style.display=menu.style.display==="none"?"block":"none"; });
    document.addEventListener("click",function(){ menu.style.display="none"; });
    menu.addEventListener("click",function(e){ e.stopPropagation(); });
    menu.querySelectorAll(".rm[data-preset]").forEach(function(b){ b.addEventListener("click",function(){ RANGE=preset(+b.getAttribute("data-preset")); if(lab)lab.textContent=RANGE.label; try{localStorage.setItem("gs_mc_range",JSON.stringify(RANGE));}catch(e){} menu.style.display="none"; load(); }); });
  }
  function init(){
    root=document.querySelector('[data-d="root"]'); if(!root)return;
    q("new-grp").onclick=function(){ openGroup(0); };
    q("import-cost").onclick=function(){ q("imp-msg").textContent=""; q("imp-modal").hidden=false; };
    q("grp-save").onclick=saveGroup; q("imp-run").onclick=runImport;
    q("det-close").onclick=function(){ q("detail").hidden=true; };
    ["grp-close","grp-cancel"].forEach(function(k){ q(k).onclick=function(){ q("grp-modal").hidden=true; }; });
    ["imp-close","imp-cancel"].forEach(function(k){ q(k).onclick=function(){ q("imp-modal").hidden=true; }; });
    initRange();
    api("/plugin/marketing-campaigns/settings").then(function(r){ if(r.ok&&r.data&&r.data.settings)CUR=r.data.settings.currency||"USD"; load(); });
  }
  /* Deep link: /marketing-campaigns?campaign=<v> opens that view directly, so it can be linked from an email,
     a dashboard widget or another report. The spelling lives in GSLink so no two pages can
     disagree about it. The inline fallback covers the window before gs-deeplink.js is deployed —
     it must ASSIGN, not return: an early return exits gsDeep() and the opener never fires.
     Anything malformed is ignored and the normal list loads. */
  function gsDeep() {
    var v = null;
    if (window.GSLink) {
      v = window.GSLink.read({ campaign: "text120" }).campaign;
    } else {
      try {
        var p = new URLSearchParams(location.search);
        v = (String(p.get("campaign") || "").trim().slice(0, 120)) || null;
      } catch (e) { v = null; }
    }
    if (v !== null && v !== "") openDetail(v);
    /* Channel pre-scope: /marketing-campaigns?channel=<name> lands filtered to that channel.
       Set only — renderChannels/renderCampaigns (run after load resolves) apply it. */
    try {
      var cp = window.GSLink ? (window.GSLink.read({ channel: "text60" }).channel) : new URLSearchParams(location.search).get("channel");
      CHANFILTER = (String(cp || "").trim().slice(0, 60)) || null;
    } catch (e) {}
  }
  ready(function () { init(); gsDeep(); });
})();
